import { IconTargetArrow } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import { numeralFormatterCurrency, percentFormatter } from 'ns_libs/formatter';
import { ITargetReturns } from './types';
import './TargetReturnsHeader.scss';

export interface ITargetReturnsHeaderProps {
    targetReturns: ITargetReturns;
}

const TargetReturnsHeader: React.FC<ITargetReturnsHeaderProps> = ({
    targetReturns,
}) => {
    const formatPercent = (value: number | null): string => {
        if (value === null) return '-';
        return percentFormatter(value) ?? '-';
    };

    const formatCurrency = (value: number | null): string => {
        if (value === null) return '-';
        return numeralFormatterCurrency(value);
    };

    return (
        <div className="TargetReturnsHeader d-flex flex-wrap mb-3">
            <div className="TargetReturnsHeader__card d-flex align-items-center justify-content-between">
                <div className="d-flex flex-row align-items-center">
                    <NSIcon icon={IconTargetArrow} className="TargetReturnsHeader__icon text-white mr-2" />
                    <span className="TargetReturnsHeader__label font-12 text-white">Target return on cost:</span>
                </div>
                <span className="TargetReturnsHeader__value font-12 text-white">
                    {formatPercent(targetReturns.returnOnCost)}
                </span>
            </div>
            <div className="TargetReturnsHeader__card d-flex align-items-center justify-content-between">
                <div className="d-flex flex-row align-items-center">
                    <NSIcon icon={IconTargetArrow} className="TargetReturnsHeader__icon text-white mr-2" />
                    <span className="TargetReturnsHeader__label font-12 text-white">Target return on equity:</span>
                </div>
                <span className="TargetReturnsHeader__value font-12 text-white">
                    {formatPercent(targetReturns.returnOnEquity)}
                </span>
            </div>
            <div className="TargetReturnsHeader__card d-flex align-items-center justify-content-between">
                <div className="d-flex flex-row align-items-center">
                    <NSIcon icon={IconTargetArrow} className="TargetReturnsHeader__icon text-white mr-2" />
                    <span className="TargetReturnsHeader__label font-12 text-white">Target profit return:</span>
                </div>
                <span className="TargetReturnsHeader__value font-12 text-white">
                    {formatCurrency(targetReturns.profitReturn)}
                </span>
            </div>
        </div>
    );
};

export default TargetReturnsHeader;
